import { NgModule } from "@angular/core";
import {
  MedBtnModule, MedBubbleModule,
  MedCardModule, MedDatepickerModule,
  MedDirectiveSharedModule,
  MedInputModule,
  MedModalModule, MedRadioGroupModule,
  MedTabGroupModule, MedUploadFileModule,
} from "@mk/med-ui";
import {
  MedIconAimbulanceModule, MedIconAlertErrorModule,
  MedIconArchiveModule, MedIconArrowCircleLeftModule, MedIconArrowRightModule, MedIconBlockModule,
  MedIconBulbModule,
  MedIconCheckCircleFillModule,
  MedIconCheckCircleModule,
  MedIconCheckModule,
  MedIconCircleModule, MedIconCloseModule,
  MedIconCommentsModule,
  MedIconDeleteModule,
  MedIconDocsModule,
  MedIconDownloadModule, MedIconInfoModule,
  MedIconPlusModule, MedIconRedoModule, MedIconRefreshModule,
  MedIconReplyModule, MedIconSuccessModule, MedIconSyncModule, MedIconViewLpModule,
  MedIconVisibilityModule,
  MedIconVisibilityOffModule,
} from "@mk/med-icons";
import { DatePipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { AccordionModule } from "primeng/accordion";
import { TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { DistributionComponent } from "@app/components/distribution/distribution.component";
import { SeriesComponent } from "@app/components/distribution/series/series.component";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { LoaderModule } from "@app/components/loader/loader.module";
import { AvatarModule } from "primeng/avatar";
import { MultiSelectModule } from "primeng/multiselect";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { TooltipModule } from "primeng/tooltip";
import {
  ViewDistributionModalComponent,
} from "@app/components/distribution/view/view-distribution-modal/view-distribution-modal.component";

@NgModule({
  declarations: [
    DistributionComponent,
    SeriesComponent,
  ],
  imports: [
    PageTitleModule,
    MedBtnModule,
    MedIconPlusModule,
    NgStyle,
    MedIconBulbModule,
    MedIconDownloadModule,
    MedIconArchiveModule,
    MedIconCheckCircleModule,
    NgClass,
    MedCardModule,
    MedIconAimbulanceModule,
    AccordionModule,
    MedIconDocsModule,
    MedIconDeleteModule,
    NgForOf,
    NgIf,
    TableModule,
    MedIconCheckCircleFillModule,
    MedIconCircleModule,
    MedDirectiveSharedModule,
    MedTabGroupModule,
    MedIconCheckModule,
    MedIconVisibilityModule,
    MedIconVisibilityOffModule,
    MedInputModule,
    FormsModule,
    MedIconReplyModule,
    MedModalModule,
    MedIconCommentsModule,
    MedUploadFileModule,
    DatePipe,
    LoaderModule,
    MedIconArrowRightModule,
    MedRadioGroupModule,
    MedIconCloseModule,
    MedDatepickerModule,
    AvatarModule,
    MultiSelectModule,
    MedBubbleModule,
    ScrollPanelModule,
    MedIconArrowCircleLeftModule,
    MedIconAlertErrorModule,
    TooltipModule,
    MedIconRefreshModule,
    MedIconSuccessModule,
    MedIconBlockModule,
    MedIconViewLpModule,
    MedIconRedoModule,
    MedIconInfoModule,
    MedIconSyncModule,
    ViewDistributionModalComponent,
  ],
  exports: [],
})
export class DistributionModule {}
